import { getBackendUrl } from "api/common";
import axios from "axios";

interface AppData {
  authUrl: string;
  clientId: string;
  userPoolId: string;
  puzzelClientId: string;
  puzzelIdpScheme?: string;
}

export const getAppData = async (): Promise<AppData> => {
  const response = await axios.get<AppData>(`${getBackendUrl()}/app-data`);
  return response.data;
};
